import { getConfigWithMetadata, hasAuthorization } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { type FindAllSearchAlertsParams, type FindAllSearchAlertsResponse } from '@pkgs/api/models';
import { findAllSearchAlerts as generatedFindAllSearchAlerts } from '@generated/search-bff/controllers/search-alert/search-alert';

/**
 * Find all search alerts of an Account using the `/api/v4/searchalert/account/{accountId}/alert` endpoint.
 * Requires a valid JWT token in the `apiConfig`.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/findAllSearchAlerts Search API Documentation}
 */
export async function findAllSearchAlerts(
  params: FindAllSearchAlertsParams,
  apiConfig: ApiConfig,
): Promise<ApiResult<FindAllSearchAlertsResponse>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'findAllSearchAlerts');

    if (!hasAuthorization(_apiConfig)) {
      console.warn(
        'JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`',
      );
    }

    const response = await generatedFindAllSearchAlerts(params, _apiConfig);
    return { status: 'success', data: response };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
